import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class MatchedContractsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/matched_contracts", { params: toSnakeCase(params) });
  }

  exportCSV(storeId) {
    return securedAxiosInstance.get("/matched_contracts/export", {
      params: { store_id: storeId },
      responseType: "blob",
    });
  }
}

export default new MatchedContractsService();
